import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { ProductTagMatchType } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  productTagFromModel,
  validateProductTagCondition,
  type ProductTagState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PRODUCT_TAG = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ProductTagState>>,
): ConditionType<ProductTagState, ModelCondition.ProductTag> => ({
  name: CONDITION_NAMES[ModelCondition.PRODUCT_TAG],
  description(state) {
    return t("Product tags: {{tags}}", { tags: state.tags.join(", ") });
  },
  Details(props: ConditionTypeDetailsProps<ProductTagState>) {
    return React.createElement(Details, props);
  },
  empty: { tags: [], matchType: ProductTagMatchType.ALL },
  fromModel(model: ModelCondition.ProductTag) {
    return productTagFromModel(model);
  },
  toModel(state) {
    return {
      type: ModelCondition.PRODUCT_TAG,
      tags: state.tags,
      matchType: state.matchType,
      evaluationTime: state.evaluationTime,
    };
  },
  valid(state) {
    return validateProductTagCondition(state).valid;
  },
});
